import classnames from "classnames";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { HuboModal } from "@components/General/HuboModal/huboModal.component";

type Props = {
    inactivityCountdown: number;
    modalState: boolean;
    toggleHandler: (newState: boolean) => void;
    logoutUser: () => void;
};

const InactivityMonitor = ({
    inactivityCountdown,
    modalState,
    toggleHandler,
    logoutUser,
}: Props) => {
    const { t } = useGranite();
    return (
        <HuboModal
            title={t("ecorner.inactivityModal.title")}
            autoFocus={false}
            centered={true}
            size={"sm"}
            modalState={modalState}
            toggleHandler={toggleHandler}
            closable={true}
            withFooter={false}
        >
            {t("ecorner.inactivityModal.text", inactivityCountdown)}
            <div
                className={classnames(
                    "d-flex w-100 m-0 mt-2 mt-sm-3 align-items-center justify-content-between",
                )}
            >
                <Button
                    test="inactivityMonitor-button-cancel"
                    color="primary"
                    type="button"
                    onClick={() => toggleHandler && toggleHandler(false)}
                >
                    {t("ecorner.inactivityModal.button.cancel")}
                </Button>
                <Button
                    test="inactivityMonitor-button-submit"
                    color={"gray"}
                    type="button"
                    onClick={() => logoutUser && logoutUser()}
                >
                    {t("ecorner.inactivityModal.button.logout")}
                </Button>
            </div>
        </HuboModal>
    );
};

export default InactivityMonitor;
